import { SdkLanguageType } from './constants';

/**
 * @readonly
 * @enum {string} an Enum containing all possible variants of environment, passed as an argument to KameleoonClient `configuration`s `environment` field
 * */
export enum Environment {
  Production = 'production',
  Staging = 'staging',
  Development = 'development',
}

/**
 * @param {SdkLanguageType} type - type of the SDK
 * @param {string} version - version of the package
 * @param {boolean} isServer - flag to indicate if the SDK is running on the server
 * */
export type ExternalPackageInfoType = {
  type: SdkLanguageType;
  version: string;
  isServer: boolean;
};
